import { defineStore } from 'pinia';

export const useEventsStore = defineStore('events', {
    state: () => ({
        upcomingEvents: [],
        conference: null,
        eventsFetched: false,
        conferenceFetched: false,
        singleEvents: {}
    }),
    actions: {
        setUpcomingEvents(events) {
            this.upcomingEvents = events;
            this.eventsFetched = true;
        },
        setConference(conference) {
            this.conference = conference;
            this.conferenceFetched = true;
        },
        getEventUrl(key) {
            return window.portal.internal_links.events_url + key + '/';
        },
        getRegistrationUrl(key) {
            return window.portal.internal_links.events_url + key + '/' + window.portal.internal_links.registration_slug + '/';
        },
        setEvent(event, key) {
            this.singleEvents[key] = event;
        },
        getEvent(key) {
            return this.singleEvents[key];
        },
        eventFetched(key) {
            return this.singleEvents.hasOwnProperty(key);
        },
        setWaitlist(waitlist, key) {
            this.singleEvents[key].waitlist = waitlist;
        },
        setPermission(permission, value, key) {
            this.singleEvents[key].can[permission] = value;
        }
    },
    persist: {
        storage: sessionStorage
    }
});
